import { first } from 'rxjs/operators';
import { BlogService, Blog } from '@app/_components/blog';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BlogComponent } from '../blog/blog.component';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConstantService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { DevelopmentService } from '@app/_components/development';
import { Router } from '@angular/router';

@Component({
    selector: 'app-blog-list',
    templateUrl: './blog-list.component.html',
    styleUrls: ['./blog-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
	

export class BlogListComponent implements OnInit {
	constructor(
		private blogService: BlogService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private constantService: ConstantService,
		private developmentService: DevelopmentService,
		private router: Router
	) {
		this.statuses = blogService.statusesWithAll;
		this.types = blogService.types
		this.typesList = blogService.typesList;
		this.typesListForFilter = [...this.types];
		this.typesListForFilter.unshift({ value: null, name: 'All' });
		this.locationCategories = this.constantService.locations;
		this.locations = this.constantService.locations;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	blogs: any;
	blog: Blog;
	locationCategories: any;
	locations: any;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;
	types: any;
	typesList: any;
	typesListForFilter: any;
	columns: any[] = [
		{ field: 'blogId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'type', header: 'Type', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'locationName', header: 'Location', width: 'auto' },
		{ field: 'developmentId', header: 'Developments', width: 'auto' },
	];
	developments: any = [];

	ngOnInit(): void {
		// this.fetchBlogs();
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
			this.loadDevelopments();
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.blogId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	loadDevelopments() {
		this.formLoading = true;
		this.developmentService.developmentSummaryList().pipe(first()).subscribe(

			data => {
				this.developments = data.data.developmentSummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-blog-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.loading = true;
			this.blogService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.loading = false;
						this.datasource = res.data.blogs;
						this.recordTotal = res.page.recordTotal;
						this.blogs = res.data.blogs;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						this.loading = false;
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false;
					  }
				);

			if (this.datasource) {
				this.blogs = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			this.loading = false;
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(blog: Blog) {
		try {
			this.loading = true;
			this.blogService.update(blog)
				.subscribe(
					(res: any) => {
						this.loading = false;
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.blogs.map((blog, i) => {
							if (blog.blogId === res.data.blog.blogId) {
								this.blogs[i] = res.data.blog;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						this.loading = false;
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.loading = false; } );
		} catch (error) {
			this.loading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(blog: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(blog));

			this.loading = true;
			this.blogService.delete(blog.blogId)
				.subscribe(
					(res: any) => {
						this.loading = false;
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.blogs.splice(this.blogs.indexOf(blog), 1);
						this.recordTotal = this.blogs.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Blog ' + blog.blogId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						this.loading = false;
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Blog ' + blog.blogId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.loading = false; } );
		} catch (error) {
			this.loading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Blog'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BlogComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addBlogCB(data);
				// this.fetchBlogs();
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(blog: Blog) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			blog: blog,
			title: 'Edit Blog'
		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(BlogComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateBlogCB(data);
				// this.fetchBlogs();
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteBlogCB(data);
				// this.fetchBlogs();
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addBlogCB(blog: Blog) {
		console.log('Adding Blog: ' + JSON.stringify(blog));
		// if we don't have a blogs array yet...
		if (!this.blogs) {
			this.blogs = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.blogs.unshift(blog);

		// no idea what this is but it is required to update the array
		this.blogs = [...this.blogs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Blog ' + blog.blogId + ' Added', life: 3000 });
	}

	updateBlogCB(blog: Blog) {
		console.log('Updating Blog: ' + JSON.stringify(blog));
		let itemIndex = this.blogs.findIndex((item: any) => item.blogId === blog.blogId);
		this.blogs[itemIndex] = blog;

		// no idea what this is but it is required to update the array
		this.blogs = [...this.blogs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Blog ' + blog.blogId + ' Updated', life: 3000 });
	}

	deleteBlogCB(blog: Blog) {
		console.log('Removing Blog: ' + blog);
		this.blogs.splice(this.blogs.indexOf(blog), 1);
		this.recordTotal = this.blogs.length;

		// no idea what this is but it is required to update the array
		this.blogs = [...this.blogs];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Blog ' + blog.blogId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.blogs ? this.first === (this.blogs.length - this.rows) : true; }
	isFirstPage(): boolean { return this.blogs ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(blog: any) {
		if (blog?.status) {
			const status = this.statuses.find((e: any) => e.value == blog.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
			this.router.navigate(['/blog-list'])
		);
	}
	
	showPaginator()
	{
		return true;
	}

	fetchBlogs() {
		this.loading = true;
		try {
			this.blogService.fetchBlogs()
				.subscribe(
					res => {
						this.loading = false;
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.blogs = res.data.blogs;
					},
					err => {
						this.loading = false;
						console.log('Getting Blog List FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {
						this.loading = false;
					});
		} catch (error) {
			this.loading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	getLocationName(blog: any) {
		if (blog?.locationId) {
			const location = this.locations.find((e: any) => e.locationId == blog.locationId);
			return location.name;
		}
		else {
			return '';
		}
	}

	getDevelopmentName(blog: any) {
		if (blog?.developmentId) {
			const development = this.developments.find((e: any) => e.developmentId == blog.developmentId);
			return development.addressDevelopmentName + ' (D)';
		}
		else {
			return '';
		}
	}

	getAdrDevelopmentName(blog: any) {
		var addressDevelopmentName = null;
		var count = 0;
		if (blog?.blogDevelopmentAPIList.length > 0){
			blog?.blogDevelopmentAPIList.forEach(blogDevelopment => {
				if(count == 0){
					addressDevelopmentName = blogDevelopment.addressDevelopmentName;
				}else{
					addressDevelopmentName = addressDevelopmentName +", "+ blogDevelopment.addressDevelopmentName+", ";
				}
				count = count + 1;
			});
		}
		return addressDevelopmentName;
	}
}
